/**
 * SmsSayfa — Sistem Ayarları › SMS sayfalarının ortak kabuğu (backlog #637): sayfa iskeleti + beş sayfa arasında gezinen sekme çubuğu.
 * Menüde her sayfanın kendi girişi vardır; sekmeler aynı sayfalar arasında geçişi kolaylaştırır (e-posta hesapları / şablonları / kayıtları gibi).
 */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Nav, NavItem, NavLink } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';

export const SMS_SEKMELERI = [
  { id: 'hesaplar', to: '/Management/SistemAyarlari/Sms/Hesaplar' },
  { id: 'gonderenAdlari', to: '/Management/SistemAyarlari/Sms/GonderenAdlari' },
  { id: 'sablonlar', to: '/Management/SistemAyarlari/Sms/Sablonlar' },
  { id: 'kayitlar', to: '/Management/SistemAyarlari/Sms/Kayitlar' },
  { id: 'bakiye', to: '/Management/SistemAyarlari/Sms/Bakiye' },
];

/** `tabsiz`: sekme çubuğu yok (duyurular gibi başka bir izinle açılan sayfalar); başlık o zaman `sekme.<aktif>` anahtarından gelir. */
const SmsSayfa = ({ aktif, tabsiz = false, children }) => {
  const { t } = useTranslation('sms');
  const baslik = t(`sekme.${aktif}`);
  useEffect(() => { document.title = `${baslik} | FDS`; }, [baslik]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={baslik} pageTitle={t('sayfaBasligi')} />
        {!tabsiz && (
        <Nav tabs className="nav-tabs-custom mb-3" data-testid="sms-sekmeleri">
          {SMS_SEKMELERI.map((s) => (
            <NavItem key={s.id}>
              <NavLink tag={Link} to={s.to} active={s.id === aktif}>{t(`sekme.${s.id}`)}</NavLink>
            </NavItem>
          ))}
        </Nav>
        )}
        {children}
      </Container>
    </div>
  );
};

export default SmsSayfa;
